export const CommonConstant = {
  CompanyInfo: [
    { id: 1, title: 'Phone:', content: '+8999999999' },
    { id: 2, title: 'Address:', content: 'Ha Noi, Viet Nam' },
    { id: 3, title: 'Email:', content: 'thelazyman193@gmail.com' },
  ],
};
